var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "input-base",
    { class: _vm.getClass, attrs: { stretched: "", transparent: "" } },
    [
      _c(
        "label",
        { staticClass: "input-label", attrs: { slot: "label" }, slot: "label" },
        [_vm._v("\n\n    " + _vm._s(_vm.$t(_vm.getLabel)) + "\n  ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { slot: "input" }, slot: "input" },
        [
          _c("vue-dropzone", {
            ref: "mediaDropzone",
            staticClass: "dropzone-target",
            attrs: {
              options: _vm.dropzoneOptions,
              id: _vm.inputName,
              url: _vm.dropzoneOptions.url
            },
            on: {
              "vdropzone-sending": _vm.sendingEvent,
              "vdropzone-complete": _vm.fileUploadAttempted,
              "vdropzone-success": _vm.checkFileResponseStatus,
              "vdropzone-thumbnail": _vm.generateThumbnail,
              "vdropzone-files-added": _vm.filesChanged,
              "vdropzone-file-added-manually": _vm.filesChanged,
              "vdropzone-removed-file": _vm.filesChanged
            }
          }),
          _vm._v(" "),
          !_vm.noMedia
            ? _c(
                "div",
                { staticClass: "gif-search" },
                [
                  _c("input-button", {
                    staticClass: "mt-3",
                    attrs: {
                      variant: "standardInput",
                      inputPlaceholder: _vm.$t("Search.gifsPlaceholder"),
                      btnStyle: "ok-style",
                      hollow: "",
                      smaller: "",
                      stretched: ""
                    },
                    on: {
                      click: function($event) {
                        return _vm.popupGifs()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.gifsPrompted
                    ? _c("input-text", {
                        staticClass: "search-text-box",
                        attrs: {
                          variant: "standardInput",
                          inputName: "giphySearch",
                          inputPlaceholder: _vm.$t("Search.gifsPlaceholder"),
                          stretched: "",
                          small: ""
                        },
                        on: { fieldUpdate: _vm.setGifQuery }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.gifsPrompted
                    ? _c("gif-display", {
                        attrs: { loading: _vm.gifsLoading, gifs: _vm.gifs },
                        on: {
                          closeGifs: _vm.closeGifs,
                          selectGif: _vm.selectGif,
                          newGifPage: _vm.newGifPage
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d8c6730", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d8c6730","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/standard/input/InputImage.vue
// module id = null
// module chunks = 